// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tr-2";
export var chatLink = "_tr-0";
export var chatText = "_tr-1";